import { ICellRendererParams } from "ag-grid-community";
import "./Renderers.css";

export function SparklineCellRenderer(params: ICellRendererParams) {
    const aggregateRow = params.node.group || params.node.rowPinned === "bottom";

    if (aggregateRow) {
        return "";
    } else {
        return params.value;    
    }
    
}
